import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const PrivateRoute = ({
  component: Component,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) {
          return <div>Carregando...</div>;
        }

        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/log_in',
                state: { from: props.location }
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
